export default class MessagesClient {
    constructor(apiClient) {
        this.emailUri = '/v3/templated_emails';
        this.apiClient = apiClient;
        this.getEmailTemplate = this.getEmailTemplate.bind(this);
        this.getEmailTemplates = this.getEmailTemplates.bind(this);
        this.postEmailTemplate = this.postEmailTemplate.bind(this);
    }
    getEmailTemplate(templateName, config) {
        return this.apiClient.get(`${this.emailUri}/${templateName}`, config);
    }
    getEmailTemplates(config) {
        return this.apiClient.get(this.emailUri, config);
    }
    postEmailTemplate(data, config) {
        return this.apiClient.post(`${this.emailUri}/${data.template}`, data, config);
    }
}
